/**
 * 文字列の 1 文字目を大文字にします
 *
 * @param first 文字列の 1 文字目
 * @param rest 文字列の 2 文字目以降
 * @param locale ロケール
 */
export function capitalize([first, ...rest]: string, locale = navigator.language) {
  return first.toLocaleUpperCase(locale) + rest.join('');
}
